// src/components/HeaderMobile.jsx
import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import '../styles/components/HeaderMobile.css';
import logoTop from '../img/logo/logo-top.png';
import logoBottom from '../img/logo/logo-bottom.png';
import IconPng from '../components/IconPng';

const NAV = [
  { label: 'ABOUT US', href: '/about' },
  // { label: 'HOW IT WORKS', href: '/how' },
  { label: 'SERVICES', href: '/services' },
  { label: 'CASES', href: '/cases' },
  { label: 'CONTACTS', href: '/contacts' },
  { label: 'FAQ', href: '/faq' },
];

const SOCIAL = [
  { name: 'X', href: 'https://x.com/your' },
  { name: 'Telegram', href: 'https://t.me/your' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/your' },
];

export default function HeaderMobile() {
  const [isOpen, setIsOpen] = useState(false);

  // 🔒 блокуємо скрол сторінки, коли меню відкрите
  useEffect(() => {
    if (isOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev;
      };
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="header-mobile">
      <div className="mobile-header-top">
        {/* Логотип з переходом на головну */}
        <div className="logo-horizontal">
          <Link to="/" aria-label="Go to home" onClick={closeMenu}>
            <img src={logoTop} alt="Logo Top" className="logo-part top" />
            <img src={logoBottom} alt="Logo Bottom" className="logo-part bottom" />
          </Link>
        </div>

        {/* Соцмережі + бургер */}
        <div className="right-block">
          <div className="mobile-socials">
            {SOCIAL.map((s) => (
              <a
                key={s.name}
                className="soc"
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.name}
              >
                <IconPng name={s.name} size={36} />
              </a>
            ))}
          </div>

          <button
            className={`burger ${isOpen ? 'open' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      {/* 🔹 бекдроп + меню */}
      <div
  className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`}
  onClick={closeMenu}
>
  <nav
    className={`mobile-menu ${isOpen ? 'open' : ''}`}
    onClick={(e) => e.stopPropagation()}
  >
            {NAV.map((item) => (
              <NavLink
                key={item.label}
                to={item.href}
                className="mobile-nav-link"
                onClick={closeMenu}          // клік по лінку → закрити
              >
                {item.label}
              </NavLink>
            ))}

            <div className="mobile-menu-socials">
              {SOCIAL.map((s) => (
                <a
                  key={s.name}
                  className="soc"
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                >
                  <IconPng name={s.name} size={32} />
                </a>
              ))}
            </div>
          </nav>
        </div>
      
    </header>
  );
}
